import type { NavigateFunction } from 'react-router-dom'
import { DOCS_URL } from '@/lib/crossDomainAuth'

export function getSafeRedirectTarget(raw: string | null): string | null {
  if (!raw?.trim()) return null

  try {
    const decoded = decodeURIComponent(raw.trim())
    if (decoded.startsWith('/') && !decoded.startsWith('//')) {
      return decoded
    }

    const url = new URL(decoded)
    if (url.origin === new URL(DOCS_URL).origin) {
      return url.toString()
    }
  } catch {
    return null
  }

  return null
}

export function applyAuthRedirect(
  navigate: NavigateFunction,
  target: string | null,
  fallback = '/chat',
): void {
  const destination = target ?? fallback
  if (destination.startsWith('http://') || destination.startsWith('https://')) {
    window.location.href = destination
    return
  }
  navigate(destination)
}
